import { Injectable, Injector } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';

import { NotificationToastRef } from '../models/toast-ref';
import { INotificationToastConfig } from '../models/toast-config';
import { NotificationToastComponent } from '../components/notification-toast/notification-toast.component';

@Injectable({
  providedIn: 'root'
})
export class NotificationToastService {
  constructor(
    private overlay: Overlay,
    private injector: Injector
  ) {}

  showNotificationToast(config: INotificationToastConfig): NotificationToastRef {
    const overlayRef = this.createOverlay();

    const notificationRef = new NotificationToastRef(overlayRef, config);

    const injector = this.createInjector(notificationRef);
    // Create portal with component
    const toastPortal = new ComponentPortal(
      NotificationToastComponent,
      null,
      injector
    );

    // Attach component to overlay
    overlayRef.attach(toastPortal);

    return notificationRef;
  }

  private createOverlay(): OverlayRef {
    const positionStrategy = this.overlay
      .position()
      .global();

    return this.overlay.create({
      positionStrategy,
      hasBackdrop: false,
      panelClass: 'toast-overlay'
    });
  }

  private createInjector(ref: NotificationToastRef): Injector {
    return Injector.create({
      providers: [
        { provide: NotificationToastRef, useValue: ref }
      ],
      parent: this.injector
    });
  }
}
